const scripts = [
    '/js/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/gsap.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/ScrollTrigger.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/ScrollToPlugin.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/Draggable.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.10.4/EasePack.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/ScrollMagic.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.8/plugins/animation.gsap.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jquery.imagesloaded/5.0.0/imagesloaded.pkgd.min.js',
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCpK1sWi3J3EbUOkF_K4-UHzi285HyFX5M&sensor=false',
    '/js/clapatwebgl.js',
    '/js/plugins.js',
    '/js/common.js',
    '/js/contact.js',
    '/js/scripts.js'
]

export { scripts }